import client, { client2 } from "../auth/client";
import { getToast } from "../common/utils";
import { WorkBenchTableData, WorkBenchTableEntity } from "../modules/ManageContract/model";

export const getContractsForTable = async (
  query: { page_size?: number; page?: number },
  reqbody: { doc_status: string }
) => {
  const res = await client.post(
    `/doc_review/list_contracts/?page_size=${query.page_size}&page=${query.page}`,
    reqbody
  );
  return res.data;
};

export const getClausesForBulkUploadTable = async (
  query: { page_size?: number; page?: number },
  reqbody: { clause_status: string[] }
) => {
  try {
    const res = await client.post(
      `/clause_check/list_clause_check_contracts/?page_size=${query?.page_size}&page=${query?.page}`,
      reqbody
    );
    return res.data;
  } catch (err) {
    return err;
  }
};

export const getClausesForBulkSummaryTable = async (
  query: { page_size?: number; page?: number },
  apiProps: { clause_document_ids: string[]; sort_by: {} }
) => {
  try {
    const res = await client.post(
      `/clause_check/clause_check_summary/?page_size=${query?.page_size}&page=${query?.page}`,
      apiProps
    );
    return res.data;
  } catch {
    // ignore
  }
};

export const getCommentsWithIdService = async (
  docId: string,
  feature?: string
) => {
  const payload: any = { doc_id: docId };
  if (feature) {
    payload.feature = feature;
  }

  const res = await client.post("/doc_review/get_google_doc_meta/", payload);
  return res.data;
};

export const getUrlForSummaryFile = async (statusArray: any) => {
  const res = await client.post("/clause_check/clause_check_summary_export/", {
    statuses: statusArray,
  });

  return res.data;
};

export const getContractCountForStatus = async () => {
  try {
    const res = await client.get("/clause_check/get_status_summary");
    return res.data;
  } catch {
    getToast("Error", "Could not fetch data");
  }
};

export const getSignedUrlUsingDocId = async (docId: string) => {
  try {
    const res = await client.post("/clause_check/get_doc_signed_url/", {
      doc_id: docId,
    });

    return res.data;
  } catch {
    // ignore
  }
};

export const getDraftingContractsForTable = async (query: {
  page_size?: number;
  page?: number;
}) => {
  const res = await client.get(
    `/draft_contract/list_contracts/?page_size=${query.page_size}&page=${query.page}`
  );
  return res.data;
};

export const getDraftingTemplatesList = async () => {
  const res = await client.get(`/draft_contract/list_templates`);
  return res.data;
};

export const getSignedUrlForContractDrafting = async (reqBody: {
  doc_id: string;
}) => {
  const res = await client.post(`/draft_contract/get_gcs_signed_url/`, reqBody);
  return res.data;
};

export const getRfxEvaluationDataForTable = async (query: {
  page_size?: number;
  page?: number;
}) => {
  const res = await client.get(
    `/rfx_evaluation/list_product_areas/?page_size=${query.page_size}&page=${query.page}`
  );
  return res.data;
};

export const listEvaluatedRfxFilesData = async (reqBody: {
  product_area_id: string;
}) => {
  const res = await client.post(
    "/rfx_evaluation/list_filter_product_area/",
    reqBody
  );
  return res.data;
};

export const getRfxGeneratorTemplatesList = async () => {
  const res = await client.get(`/generate_rfx/list_templates`);
  return res.data;
};

export const getGeneratedRfxContractsForTable = async (query: {
  page_size?: number;
  page?: number;
}) => {
  const res = await client.get(
    `/generate_rfx/list_all_generated_rfx/?page_size=${query.page_size}&page=${query.page}`
  );
  return res.data;
};

export const getProjectMappings = async () => {
  const res = await client2.get("common/get_project_mappings/");
  return res.data;
};

export const updateProjectMappings = async (projectName: any) => {
  const response = await client2.post("common/update_project_mappings/", {
    project_name: projectName,
  });
  return response.data;
};

export const getWorkBenchDataForTable = async (params: any, newEntry?: WorkBenchTableEntity): Promise<WorkBenchTableData> => {
  // Call the sourcing hub API to fetch real workbench sourcing requests
  try {
    const res = await client.get(
      `/sourcing_hub/business_user/list_all_sourcing_requests/?page_size=${params?.page_size}&page=${params?.page}`
    );

    // If a newEntry is provided (from local create), prepend it to results
    const results = res?.data?.results || [];
    if (newEntry?.request) {
      // convert newEntry into a plain object compatible with API shape
      results.unshift({
        request_name: newEntry.request,
        status: newEntry.status,
        budget: newEntry.budget,
        category_manager_name: newEntry.categorymanager,
        document_drive_link: newEntry.document_drive_link,
        document_gcs_path: newEntry.document_gcs_path,
        documents: newEntry.doc_id ? [{ id: newEntry.doc_id }] : [],
      });
    }

    return new WorkBenchTableData(res?.data || { count: 0, results: [] });
  } catch {
    // Fallback to empty data on error
    return new WorkBenchTableData({ count: 0, results: [] });
  }
};

export const getSourcingHubRequestsList = async (query: { page_size?: number; page?: number }) => {
  const res = await client.get(
    `/sourcing_hub/business_user/list_all_sourcing_requests/?page_size=${query.page_size}&page=${query.page}`
  );
  return res.data;
};

